var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control m-input",class:_vm.inputClass,attrs:{"name":_vm.name,"id":_vm.id}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('Please choose')))]),_vm._v(" "),_vm._l((_vm.options),function(value,key){return _c('option',{key:key,domProps:{"value":value}},[_vm._v(_vm._s(value))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05013758","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/form/inputs/SelectableComponent.vue
// module id = null
// module chunks = 